import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IGeogebraState {
  geogebraAppName: string;
}

const initialState: IGeogebraState = {
  geogebraAppName: '',
};

const geogebraSlice = createSlice({
  name: 'geogebra',
  initialState,
  reducers: {
    setGeogebraAppName: (state, action: PayloadAction<string>) => {
      state.geogebraAppName = action.payload;
    },
  },
});

export const { setGeogebraAppName } = geogebraSlice.actions;

export const { reducer: geogebraReducer } = geogebraSlice;
